// extracted by mini-css-extract-plugin
module.exports = {"WorkPortfolio":"WorkPortfolio_WorkPortfolio__1hYfR"};